import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';

const SpinnerVariant = {
  INLINE: 'inline',
  LEFT_INLINE: 'left-inline',
};

const SpinnerSize = {
  XS: 'xs',
  SM: 'sm',
};

const GetSpinnerIconSize = (size) => (size === SpinnerSize.XS ? '1rem' : 40);

const withSpinner = (children, doShowSpinner, label, variant, size, parentClass) => {
  let html = null;
  if (doShowSpinner) {
    html = (
      <div
        className={clsx(
          'text-center',
          parentClass,
          { 'flex items-center justify-center': variant === SpinnerVariant.INLINE },
          { 'flex flex-row place-items-center gap-2': variant === SpinnerVariant.LEFT_INLINE },
        )}
      >
        <CircularProgress
          color="secondary"
          size={GetSpinnerIconSize(size)}
          className={clsx({ 'mr-2 align-text-top inline': variant === SpinnerVariant.INLINE })}
        />
        {label && (
          <div className={clsx({ inline: SpinnerVariant.INLINE === variant })}>{label}</div>
        )}
      </div>
    );
  } else {
    html = children();
  }

  return html;
};

SpinnerVariant.propTypes = {
  children: PropTypes.func.isRequired,
  doShowSpinner: PropTypes.bool.isRequired,
  label: PropTypes.string,
  parentClass: PropTypes.string,
};

SpinnerVariant.defaultProps = {
  label: '',
  parentClass: undefined,
};

export default withSpinner;
